/**
 * SECTION ENTRANCE (2026-09-28, PDP).
 *
 * Every section below the first screen waits 3.5% of its own height low and
 * glides up to place over 1s the moment its top reaches the bottom of the
 * screen. Once per section, no fade. Copied from the reference's PDP, phone
 * and desktop: GSAP `from({yPercent: 5})`, 1s, trigger "top bottom", GSAP's
 * default ease power1.out = (1 - t)^2 remaining. Recorded frame by frame on a
 * virtual clock, the reference leaves 55.6 / 24.2 / 5.6% of the shift at
 * 250 / 500 / 750ms; EASE below leaves 56.4 / 25.1 / 6.1% (plain CSS ease-out
 * would leave 62 / 32 / 9). Evidence and the side-by-side videos:
 * docs/调研/卡片骨架对标_Rhode_2026-09-27/.
 *
 * Two deliberate differences, both about distance. The reference moves 5% of
 * the section; its PDP sections are ~720px tall on a phone (median), so a
 * typical one travels ~35px. Ours are ~1000px (median), so 5% made them travel
 * ~50px, and Leo read that as more than the reference (9-28). SHARE is scaled
 * by that height ratio so a typical section travels what the reference's does.
 * MAX_SHIFT keeps the ~2600px reviews wall in line with the other large cards
 * (Leo asked for that one to move less, 9-28).
 *
 * Sections holding a position:fixed element are skipped: a transformed
 * ancestor re-anchors fixed children to itself (the sticky buy bar would ride
 * along). Reduced motion switches the whole thing off.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!Element.prototype.animate) return;
  // The tag lives in the buy-zone section; if a re-render ever re-inserts it,
  // the page must not arm a second time.
  const root = document.documentElement;
  if (root.dataset.d2Entrance) return;
  root.dataset.d2Entrance = '1';

  const SHARE = 0.035;
  const MAX_SHIFT = 40;
  const DURATION = 1000;
  const EASE = 'cubic-bezier(0.5, 1, 0.89, 1)';

  const hasFixedChild = (section) =>
    Array.from(section.querySelectorAll('*')).some((el) => getComputedStyle(el).position === 'fixed');

  // Only sections still below the screen are armed. Anything already on
  // screen, or above it (a restored scroll position), is left where it is.
  const pending = [];
  document.querySelectorAll('main .shopify-section').forEach((section) => {
    const rect = section.getBoundingClientRect();
    if (rect.height === 0 || rect.top < window.innerHeight) return;
    if (hasFixedChild(section)) return;
    const shift = Math.round(Math.min(rect.height * SHARE, MAX_SHIFT) * 100) / 100;
    section.style.transform = `translateY(${shift}px)`;
    pending.push({ section, shift });
  });
  if (!pending.length) return;

  let queued = false;
  const check = () => {
    queued = false;
    const bottom = window.innerHeight;
    for (let i = pending.length - 1; i >= 0; i--) {
      const { section, shift } = pending[i];
      // The untransformed top, so the start matches the reference's trigger.
      if (section.getBoundingClientRect().top - shift < bottom) {
        section.style.transform = '';
        section.animate([{ transform: `translateY(${shift}px)` }, { transform: 'translateY(0)' }], {
          duration: DURATION,
          easing: EASE,
        });
        pending.splice(i, 1);
      }
    }
    if (!pending.length) {
      document.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', onScroll);
    }
  };
  const onScroll = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(check);
  };

  // Horizon scrolls .page-wrapper on the desktop and the document on phones;
  // the capture phase on the document hears both (see assets/d2-zoom.js).
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });
  check();
})();
